<eg-card-table class="px-20 py-10" fxFlex="100" [columns]="tableColumns" [dataSource]="historyItems" [showAction]="false">
  <ng-template #emptyTableTemplate>
    <div fxFlex="100" *transloco="let translate">
      <eg-alert type="info" message="{{ translate('nothingFound') }}"></eg-alert>
    </div>
  </ng-template>
</eg-card-table>
